/**
 * Returns promise of preloaded HTMLImageElement.
 *
 * @param src
 * @param image
 */
export function preloadHtmlImage(
  src: string,
  image = new Image()
): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const cleanup = () => {
      image.onload = null;
      image.onerror = null;
    };

    image.onload = () => {
      cleanup();
      resolve(image);
    };

    image.onerror = () => {
      cleanup();
      reject(new Error(`Couldn't load image "${src}"`));
    };
    image.src = src;
  });
}
